module.exports = __webpack_public_path__ + "static/media/swimming.bd0f90da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/swimming.svg
// module id = 399
// module chunks = 7